import * as actions from './actions';
import * as getters from './getters';
import {FETCH_EVENTS_LIST } from '../../mutation-types';


const mutations = {
  [FETCH_EVENTS_LIST](state, payload) {
    state.eventList = payload
  },
};

const state = {
  eventList: null,
  url: '/v1/events-by-location'
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
